import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ARRAY } from '@e-socna/empty';

import { SplashScreen } from '../../components/SplashScreen';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';
import { Loading } from '../../components/Loading';
import { SaveToBookmarks } from '../../components/Illustrations/SaveToBookmarks';
import { PATH_FOLDERS_NEW } from '../../app/constants/paths.constant';
import { FolderBusinessEntityList } from '../../components/FolderBusinessEntityList';
import { FolderBusinessEntityListVariant } from '../../components/FolderBusinessEntityList/enums/variant.enum';

export const FoldersPage_FoldersWithOpenState_QueryDocument = graphql(`
  query FoldersPage_FoldersWithOpenState_Query {
    findFoldersWithOpenState {
      ...FolderBusinessEntityListCmp_FolderBusinessEntity_Fragment
    }
  }
`);

export const OpenFolders = () => {
  const navigate = useNavigate();

  const { data, isLoading } = useGraphQLQuery(
    FoldersPage_FoldersWithOpenState_QueryDocument,
  );

  const goToCreationPage = useCallback(
    () => void navigate(PATH_FOLDERS_NEW),
    [navigate],
  );

  if (isLoading) {
    return <Loading />;
  }

  const folders = data?.findFoldersWithOpenState ?? EMPTY_ARRAY;

  if (!folders.length) {
    return (
      <SplashScreen
        action={{ label: 'Créer un Dossier', onClick: goToCreationPage }}
        illustration={<SaveToBookmarks />}
        message="Vous n'avez pas de dossier ouvert pour le moment. Commencez le travail !"
      />
    );
  }

  return (
    <FolderBusinessEntityList
      folderBusinessEntities={folders}
      onStartCreate={goToCreationPage}
      variant={FolderBusinessEntityListVariant.Cards}
    />
  );
};
